import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>In the tables on the following pages, write the names of three
                                                managers you have worked with or
                                                for, under the titles at the top of the table.</p>
                                            <span className="uiheading">  <p>From the five solutions listed, identify two demonstrated by each of your managers. Then, for
                            each manager, choose one solution which has influenced your own way of trying to achieve
                            effective delivery. As you write your answers in the table (or in a notepad, if it's easier) think about
                            the following:</p></span>
                                            <ul className="greenbullet-list"
                                                style={{marginBottom: '0px !important'}}>
                                                <li>How did this solution impact on the delivery of the work or
                                                    project?
                                                </li>
                                                <li>Was it a key driver for success?</li>
                                                <li>Think of a time when you have used that solution; how
                                                    effective was it?
                                                </li>
                                                <li style={{paddingBottom: '0px !important'}}>What did you learn
                                                    about your ability to deliver?
                                                </li>
                                            </ul>
                                            <div className="mobile-scroll">
                                                <div className="circle_title referencepad"><img
                                                    src={require('@images/Browndot.png')}
                                                    alt=""/>DELIVERY SOLUTIONS EXERCISE
                                                </div>
                                                <div className="innovativeimg image-bg1">
                                                    <div className="text-area1">
                                                        <input type="text"
                                                               className="star-text"
                                                               name="input"
                                                               tag="16"
                                                               value={this.props.pageData?.Manager1?.input}
                                                               onChange={this.props.handleChangePageData('Manager1')}/>
                                                    </div>
                                                </div>
                                                <div className="innovativeimg image-bg2">
                                                    <div className="text-area2">
                                                        <input type="text"
                                                               className="star-text"
                                                               name="input"
                                                               tag="18"
                                                               value={this.props.pageData?.Manager2?.input}
                                                               onChange={this.props.handleChangePageData('Manager2')}/>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page7')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}